import React, { useState, useEffect } from "react";
import axios from "axios";
import { GET_APP_REPORTS, MARK_REPORT_RESOLVED } from "URLRoutes";
import { generateURLOptions } from "URLOptions";
import CommonReportCard from "components/common/CommonReportCard";
import Swal from "sweetalert2";
import FilledButton from "components/InterstellrComponents/FilledButton";
import UpdateAdminUsersModal from "./Modals/UpdateAdminUsersModal";

const AppReports = () => {
  const [reports, setReports] = useState([]);

  const [showUsers, setShowUsers] = useState(false);

  useEffect(() => {
    document.title = "App Reports | Administration Panel | Mind Pulse";
    getAppReports();
  }, []);

  const getAppReports = async () => {
    try {
      const response = await axios.get(GET_APP_REPORTS, {
        headers: generateURLOptions(),
      });
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      console.log("Reports: ", response.data);
      setReports(response?.data?.data);
    } catch (error) {
      console.error("Get Reports Error: ", error);
      alert(error);
    }
  };

  const markReportResolved = async (report) => {
    try {
      const response = await axios.post(
        MARK_REPORT_RESOLVED,
        {
          reportId: report,
        },
        {
          headers: generateURLOptions(),
        }
      );
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }
      getAppReports();
    } catch (error) {
      console.error("Update Reports Error: ", error);
      alert(error);
    }
  };

  const markResolved = (id) => {
    Swal.fire({
      title: "Mark Report as Resolved",
      text: "Are you sure you want to mark this report as resolved? The user that submitted this feedback will be notified.",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Mark Resolved",
    }).then(async (result) => {
      if (result.isConfirmed) {
        return markReportResolved(id);
      }
    });
  };

  return (
    <>
      <UpdateAdminUsersModal
        isOpen={showUsers}
        onClose={() => setShowUsers(false)}
      />
      <div className="w-full px-8">
        {/* Heading Area */}
        <div className="flex flex-row mt-8">
          <div className="flex flex-col">
            <h4 className="font-medium text-lg">App Reports</h4>
            <p className="font-light text-base">
              {reports?.length ?? 0} Reports
            </p>
          </div>
          <div style={{ flex: 1 }} />
          <div className="w-1/5">
            <FilledButton
              text={"Update Admin Users"}
              borderRadius={96}
              onPress={() => setShowUsers(true)}
            />
          </div>
        </div>

        {/* Render Users */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-2 mt-2">
          {reports?.map((report) => (
            <CommonReportCard
              report={report}
              onResolve={(report) => markResolved(report?._id)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default AppReports;
